
import Profile from '../components/Profile'
import Settings from '../components/Settings'
import Billing from '../components/Billing'

import Admin from '../components/Admin/Admin'
import Devices from '../components/Devices/Devices'
import DeviceDetail from '../components/Devices/DeviceDetail'

import AlertHistory from '../components/Alerts/AlertHistory'
import AlertList from '../components/Alerts/AlertList'
import AlertSave from '../components/Alerts/AlertSave'

import Dashboard from '../components/Dashboard/Dashboard.vue'

import Verify_Device from '../components/Verification/VerifyDevice'
import Select_Device from '../components/Verification/SelectDevice'
import QR_Reader from '../components/Verification/QRReader'
import Self_Install_Details from '../components/InstallationStepper/SelfInstallDetails'
import Installation_Stepper from '../components/InstallationStepper/InstallationStepper'

import Router from 'vue-router'
import Vue from 'vue'
import { is_user_admin } from '../helpers/roles'

Vue.use(Router)
let router = new Router({
    routes: [

        { path: '/admin', name: 'Admin', component: Admin, meta: { requiresAdmin: true } },
        { path: '/profile', name: 'Profile', component: Profile },
        { path: '/settings', name: 'Settings', component: Settings },
        { path: '/billing', name: 'Billing', component: Billing, meta: { requiresAdmin: true } },

        { path: '/devices', name: 'Devices', component: Devices },
        { path: '/device/:id', name: 'DeviceDetail', component: DeviceDetail, props:true },

        { path: '/alerts', name: 'AlertList', component: AlertList },
        { path: '/alertHistory', name: 'AlertHistory', component: AlertHistory },
        { path: '/alerts/create', name: 'AlertCreate', component: AlertSave },
        { path: '/alerts/create/:device_id', name: 'Create Alert by Device', component: AlertSave },
        { path: '/alerts/:id', name: 'AlertEdit', component: AlertSave, props:true },
        { path: '/verify/qr', name: 'QR Reader', component: QR_Reader },
        { path: '/verify/:imei', name: 'Verify Device', component: Verify_Device, props: true },
        { path: '/install', name: 'Install', component: Select_Device },
        { path: '/selfinstall', name: 'Select Device', component: Select_Device, props: true },
        { path:'/installation/create/:imei', name: 'Create Installation by IMEI', component: Installation_Stepper, props: true },
        { path:'/selfinstall/device/:imei', name: 'FinishSelfInstall', component: Self_Install_Details, props: true },
        { path: '/*', name: 'Dashboard', component: Dashboard },
    ]
})



router.beforeEach((to, _, next) => {
    if (to.matched[0].path === '/install') {
        localStorage.setItem('authenticated', true)
        localStorage.setItem('self_install_user', true)
        localStorage.setItem('active_user', true)
        localStorage.setItem('user', 
            JSON.stringify({"email":"","userId":0,"accountId":0,"roleCode":"SIU","firstName":"Self Install","lastName":"User","accountStatus":"P"}))
        router.push('/selfinstall')
    } else {
        if(to.matched.some(record => record.meta.requiresAdmin)){
            is_user_admin()
                ? next()
                : next({ path: '/login' })
        } else if(to.matched.some(record => record.meta.guest)) {
            localStorage.getItem('jwt') === null
                ? next()
                : next({ name: 'home'})
        } else {
            next()
        }
    }
})
 
export default router
